import React from "react";
import { useTranslation } from "react-i18next";
//
import { Box } from "@mantine/core";
//
import { PageHeader } from "./page-header/page-header";

export const RouterGenericError = React.memo(function RouterGenericError() {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader />
      <Box w={{ sm: "100%", md: "80%" }} mx="auto" mt="xl">
        <h1>{t("routerErrorPage.header")}</h1>

        <p>{t("routerErrorPage.body")}</p>
      </Box>
    </>
  );
});
